import { FC } from 'react';
import { ISelectOption } from 'interfaces';

import { LineTextSelect } from '../LineTextSelect';

const timelineScaleOptions: ISelectOption<string>[] = [
  {
    value: '7days',
    label: '7 дней',
  },
  {
    value: '30days',
    label: '30 дней',
  },
  {
    value: '90days',
    label: '90 дней',
  },
  {
    value: '180days',
    label: '180 дней',
  },
];

const markerTypeOptions: ISelectOption<string>[] = [
  {
    value: 'imagery',
    label: 'Снимки',
  },
  {
    value: 'objects',
    label: 'Объекты',
  },
  {
    value: 'operational',
    label: 'События',
  },
];

interface TimelineSettingsProps {
  currentScale: string;
  handleChangeCurrentScale: (value: string) => void;
  currentMarkerTypes: string[];
  handleChangeCurrentMarkerTypes: (value: string) => void;
}

export const TimelineSettings: FC<TimelineSettingsProps> = ({
  currentScale,
  handleChangeCurrentScale,
  currentMarkerTypes,
  handleChangeCurrentMarkerTypes,
}) => {
  return (
    <div className="flex flex-row gap-3 justify-start h-6 border-solid border-t-[1px] rounded-[inherit] rounded-t-none border-tpg_light bg-dark align-middle">
      <LineTextSelect
        title="Масштаб:"
        value={currentScale}
        options={timelineScaleOptions}
        classNames={{
          container: 'max-w-[40%] ml-2 mt-0.5',
          options: '!w-[120px] !-top-[150px]',
        }}
        onSelect={handleChangeCurrentScale}
        menuPlacement="top"
      />
      <LineTextSelect
        title="Показывать:"
        value={currentMarkerTypes}
        options={markerTypeOptions}
        classNames={{
          container: 'max-w-[40%] ml-2 mt-0.5',
          options: '!w-[200px] !-top-[120px]',
        }}
        onSelect={handleChangeCurrentMarkerTypes}
        isMultiple
        menuPlacement="top"
      />
    </div>
  );
};
